import { RaisinContainer as Container, Typography } from '@raisin/components-lib';
import React from 'react';
import { injectIntl } from 'react-intl';
import * as S from './styles';
const UsContactBanner = ({ contactData }) => {
    const emailAddress = contactData.email.email_address;
    const emailLinkText = contactData.email.email_link_text;
    const phoneNumber = contactData.phone.phone_number;
    const phoneLinkText = contactData.phone.phone_link_text;
    const availability = contactData.availability;
    return (React.createElement(S.Background, null,
        React.createElement(Container, { maxWidth: "xl" },
            React.createElement(S.Wrapper, null,
                React.createElement(S.InnerWrapper, null,
                    React.createElement(Typography, { variant: "body1" },
                        React.createElement(S.ContactInfo, null,
                            "Email:",
                            ' ',
                            React.createElement(S.ContactLink, { href: `mailto:${emailAddress}` }, emailLinkText || emailAddress)),
                        React.createElement(S.ContactInfo, null,
                            "Call:",
                            ' ',
                            React.createElement(S.ContactLink, { href: `tel:+1${phoneNumber}` }, phoneLinkText || phoneNumber)),
                        React.createElement(S.ContactInfo, null, availability)))))));
};
export default injectIntl(UsContactBanner);
//# sourceMappingURL=index.js.map